import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import { Play, Instagram } from "lucide-react";

export default function ReelsWall() {
    const [reels, setReels] = useState([]);
    useEffect(() => { client.get("/reels").then(r => setReels(r.data)); }, []);
    if (reels.length === 0) return null;

    return (
        <section className="py-20 md:py-24 bg-[color:var(--warm-black)] text-[color:var(--ivory)]" data-testid="reels-wall">
            <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
                    <div>
                        <div className="eyebrow text-[color:var(--champagne)] flex items-center gap-2"><Instagram size={14} /> @singhjewellers</div>
                        <h2 className="font-serif-luxe text-4xl md:text-5xl mt-3">Reels from the Showroom</h2>
                        <p className="text-white/60 text-sm mt-3 max-w-lg">A window into our Kotdwar showroom — new pieces, bridal fittings, and stories from the hills.</p>
                    </div>
                    <a href="https://www.instagram.com/singhjewellers/" target="_blank" rel="noreferrer" className="text-[11px] tracking-[0.22em] font-semibold text-[color:var(--champagne-light)] link-underline self-start md:self-auto" data-testid="reels-follow">
                        FOLLOW US →
                    </a>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
                    {reels.slice(0, 6).map(r => (
                        <a key={r.id} href={r.url} target="_blank" rel="noreferrer"
                            className="group relative block aspect-[9/16] overflow-hidden bg-[color:var(--charcoal)]"
                            data-testid={`reel-${r.id}`}
                        >
                            <img src={r.thumbnail} alt={r.title} loading="lazy"
                                className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20" />
                            <div className="absolute top-3 right-3 bg-black/40 backdrop-blur rounded-full p-1.5 border border-white/20">
                                <Play size={12} className="text-white fill-white" />
                            </div>
                            <img className="watermark" src="/logo-watermark.png" alt="Singh Jewellers" />
                            <div className="absolute inset-x-0 bottom-0 p-3">
                                <div className="text-[10px] tracking-[0.2em] uppercase text-[color:var(--champagne-light)] mb-1">Reel</div>
                                <div className="font-serif-luxe text-sm md:text-base leading-tight text-white line-clamp-2">{r.title}</div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
